import ImageCarouselDialog from './ImageCarouselDialog';

export default ImageCarouselDialog;
